import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-user",
  "use": "icon-user-usage",
  "viewBox": "0 0 56 61.5",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 56 61.5\" id=\"icon-user\"><defs><style>#icon-user .cls-1{fill:#828282}</style></defs><g id=\"icon-user_图层_2\" data-name=\"图层 2\"><g id=\"icon-user_图层_1-2\" data-name=\"图层 1\"><path class=\"cls-1\" d=\"M14 14A14 14 0 1 0 28 0a14 14 0 0 0-14 14zM56 61.5H0c0-27.23 18.89-31 18.89-31l7.47 12.56v-3.9c-2.91-4.28.81-6.17 1.57-6.51h.14c.76.34 4.48 2.22 1.57 6.48V43L37 30.5s19 3.9 19 31z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol